
import Modal from 'Src/js/components/Modal.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'RoadHazardProtectionModal',
	components: {
		Modal,
	},
})
class RoadHazardProtectionModal extends Vue { }

export default RoadHazardProtectionModal;
